import slice, { getCashPaymentAvailability } from './paymentAvailability.slice';
export { getCashPaymentAvailability };
export default slice.reducer;
